import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

// Cria instância Axios apontando para o endpoint principal
const axiosInstance = createAxiosInstance(`${REACT_APP_ESTEIRA_BACK}/rest/importacaoArquivoRemessaAquisicao`);

export default class RemessasService {
  axios: typeof axiosInstance;

  constructor() {
    this.axios = axiosInstance;
  }

  // Listar remessas com paginação
  async listar(page: number = 0, size: number = 10): Promise<any> {
    try {
      const response = await this.axios.get('/listar', {
        params: { page, size },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar remessas:', error);
      throw error;
    }
  }

  // Upload de arquivo
  async upload(formData: FormData): Promise<any> {
    try {
      const response = await this.axios.post('/processarDoc', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar remessa:', error);
      throw error;
    }
  }

  // Download de arquivo por ID ou UUID
  async download(id: number | string): Promise<Blob> {
    try {
      const response = await this.axios.get(`/${id}/download`, {
        responseType: 'blob',
        headers: { Accept: 'text/plain' },
      });
      return new Blob([response.data], { type: 'text/plain' });
    } catch (error) {
      console.error('Erro ao baixar arquivo da remessa:', error);
      throw error;
    }
  }

  // Desfazer uma remessa
  async desfazer(idRemessa: number): Promise<any> {
    try {
      const response = await this.axios.post('/desfazer', null, {
        params: { idRemessa },
      });
      return response.data;
    } catch (error) {
      console.error(`Erro ao desfazer remessa ${idRemessa}:`, error);
      throw error;
    }
  }

  // Processar arquivo de remessa de aquisição
  async exportarCsv(idAquisicao: number): Promise<Blob> {
    try {
        const response = await this.axios.get('/exportarCsv', {
        params: { id_aquisicao: idAquisicao },
        responseType: 'blob',
        headers: { Accept: 'text/csv' },
        });
        return new Blob([response.data], { type: 'text/csv' });
    } catch (error) {
        console.error('Erro ao exportar CSV da remessa de aquisição:', error);
        throw error;
    }
  }

  async listarLogsOutrosStatus(idAquisicao: number): Promise<any[]> {
    try {
      const response = await this.axios.get('/listarLogsOutrosStatus', {
        params: { id_aquisicao: idAquisicao },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar logs com outros status:', error);
      throw error;
    }
  }

}
